import React from 'react';

const Loading = () => (
  <progress className="progress is-large is-primary" max="100">
    60%
  </progress>
);

export default Loading;
